<template>
  <div class="home">
    <a-row :gutter="16">
      <a-col :span="24">
        <a-card title="Kontakt">
          <a-row :gutter="16">
            <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" :xxl="8" style="text-align: center">
              <h2>Adres e-mail</h2>
              <p>akademiki@mail.togi.cloud</p>
            </a-col>
            <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" :xxl="8" style="text-align: center">
              <h2>Telegram</h2>
              <p>@akademiki_bot</p>
            </a-col>
            <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" :xxl="8" style="text-align: center">
              <h2>Formularz - FAQ</h2>
              <p><a href="https://akademiki.togi.me/" target="_blank">Centrum Pomocy</a></p>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
    };
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventRefresh);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventRefresh);
    });
  },
  mounted() {
    this.$emit("loadedView");
  },
};
</script>
